import React from "react";
import "../../CSS/Industries.css";

function Healthcare() {
    return (
        <>
            
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">
                    <div className="industry-detail-hero-content">

                        <h1>Solutions for Healthcare</h1>
                        <p style={{ color: '#FF7D37' }}>
                            Digital solutions that help healthcare organizations
                            manage information, workflows, communication, and
                            operational processes.
                        </p>
                    </div>
                </div>
            </section>


            <section className="industry-detail-section">
                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">


                            <h2>
                                Digital Solutions for Healthcare Organizations
                            </h2>

                            <p>
                                Healthcare organizations depend on efficient
                                systems to manage information and everyday
                                operations.
                            </p>

                            <p>
                                We build customized websites, applications,
                                management systems, and databases according
                                to organizational requirements.
                            </p>

                        </div>

                        <div className="col-lg-6">

                            <img
                                src="/images/home/healthcare.png"
                                alt="Healthcare Technology Solutions"
                                className="industry-detail-image"
                            />

                        </div>

                    </div>

                </div>
            </section>


            <section className="industry-features">

                <div className="container">

                    <div className="section-heading text-center">

                        <h2>Technology for<br /> Healthcare</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-person-vcard"></i>
                            <h3>Patient Management</h3>
                            <p>Digital systems for managing patient information and workflows.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-calendar-check"></i>
                            <h3>Appointment Systems</h3>
                            <p>Online appointment and scheduling solutions.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-database"></i>
                            <h3>Data Management</h3>
                            <p>Organized database solutions for business information.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-laptop"></i>
                            <h3>Healthcare Applications</h3>
                            <p>Custom web and software applications for healthcare operations.</p>
                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default Healthcare;